import { Box, Typography, Grid } from "@mui/material";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

export default function HowWeWork() {
  const { t } = useTranslation("heropage");
  const steps = t("howWeWork.steps", { returnObjects: true });

  return (
    <Box
      sx={{
        px: { xs: 3, md: 12 },
        py: { xs: 14, md: 22 },
        backgroundColor: "#F6F5F3",
      }}
    >
      {/* Editorial Heading */}
      <Box sx={{ maxWidth: 900, mb: 18 }}>
        <Typography
          sx={{
            fontFamily: "Playfair Display",
            fontSize: { xs: "2.6rem", md: "3.8rem" },
            lineHeight: 1.15,
            mb: 5,
          }}
        >
          {t("howWeWork.title")}
        </Typography>

        <Typography
          sx={{
            fontFamily: "Inter",
            fontSize: "1.1rem",
            lineHeight: 2,
            color: "#444",
          }}
        >
          {t("howWeWork.intro")}
        </Typography>
      </Box>

      {/* Process Steps */}
      <Grid container spacing={10}>
        {steps.map((step, index) => (
          <Grid item xs={12} md={6} key={index}>
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9, delay: index * 0.08 }}
            >
              <Box
                sx={{
                  p: { xs: 4, md: 6 },
                  borderRadius: "20px",
                  backgroundColor: "#FFFFFF",
                  boxShadow: "0 30px 70px rgba(0,0,0,0.08)",
                  height: "100%",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Playfair Display",
                    fontSize: "1.5rem",
                    mb: 3,
                  }}
                >
                  {step.title}
                </Typography>

                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "0.98rem",
                    lineHeight: 1.9,
                    color: "#555",
                    whiteSpace: "pre-line",
                  }}
                >
                  {step.body}
                </Typography>
              </Box>
            </motion.div>
          </Grid>
        ))}
      </Grid>

      {/* Closing Statement */}
      <Box sx={{ maxWidth: 820, mt: 18 }}>
        <Typography
          sx={{
            fontFamily: "Playfair Display",
            fontSize: "2rem",
            lineHeight: 1.4,
          }}
        >
          {t("howWeWork.closing")}
        </Typography>
      </Box>
    </Box>
  );
}
